import { createContext, useContext } from "react";

interface SearchHighlightContextType {
  searchQuery: string;
  currentMatchIndex: number;
  totalMatches: number;
  matchedMessageIds: string[];
}

export const SearchHighlightContext = createContext<SearchHighlightContextType>(
  {
    searchQuery: "",
    currentMatchIndex: -1,
    totalMatches: 0,
    matchedMessageIds: [],
  }
);

export const useSearchHighlight = () => useContext(SearchHighlightContext);

